"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
function _templateObject() {
    var data = _taggedTemplateLiteralLoose(["\n    display: flex;\n    justify-content: space-between;\n\n    @media(max-width: ", ") {\n        flex-direction: column;\n        .org {\n            margin-bottom: var(--gutter-small-2);\n        }\n    }\n\n    .org {\n        margin-right: var(--gutter-small);\n    }\n\n    .tags-container {\n        display: flex;\n        flex-wrap: wrap;\n\n        @media(min-width: calc(", " + 1px)) {\n            justify-content: flex-end;\n        }\n    }\n"]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) {
    raw = strings.slice(0);
} strings.raw = raw; return strings; }
const react_1 = __importDefault(require("react"));
const styled_1 = __importDefault(require("@emotion/styled"));
const variables_1 = require("../styles/variables");
const Tag_1 = __importDefault(require("./Tag"));
var StyledCompanyAndTags = styled_1.default.div(_templateObject(), variables_1.breakpoints.large, variables_1.breakpoints.large);
var CompanyAndTags = function CompanyAndTags(_ref) {
    var organisation = _ref.organisation, tags = _ref.tags;
    return /*#__PURE__*/ react_1.default.createElement(StyledCompanyAndTags, {
        className: "name-tags"
    }, /*#__PURE__*/ react_1.default.createElement("div", {
        className: "org"
    }, organisation), /*#__PURE__*/ react_1.default.createElement("div", {
        className: "tags-container"
    }, tags.map(function (tag, i) {
        return /*#__PURE__*/ react_1.default.createElement(Tag_1.default, {
            text: tag,
            key: i + tag
        });
    })));
};
exports.default = CompanyAndTags;
